import { Tooltip } from 'antd';

export const ASSESSMENT_OPTIONS = [
    { value: 'unset', label: 'Не оценено' },
    { value: 'yes', label: 'Да' },
    { value: 'no', label: 'Нет' },
];

export const TASK_PRIORITIES = [
    { value: 0, label: 'Не оценено', action: 'Важность или срочность ещё не определена' },
    { value: 1, label: 'Важно и срочно', color: 'red', action: 'Сделать сейчас' },
    { value: 2, label: 'Важно, не срочно', color: 'blue', action: 'Запланировать' },
    { value: 3, label: 'Срочно, не важно', color: 'orange', action: 'Делегировать' },
    { value: 4, label: 'Не важно и не срочно', action: 'Отложить или исключить' },
];

export const assessmentChoice = (value) => value == null ? 'unset' : value ? 'yes' : 'no';
export const assessmentFlag = (value) => value === 'yes' ? true : value === 'no' ? false : null;

const TaskPriority = ({ priority }) => {
    const descriptor = TASK_PRIORITIES.find((item) => item.value === priority) ?? TASK_PRIORITIES[0];
    const hint = `${descriptor.label} — ${descriptor.action}`;
    return (
        <Tooltip title={hint}>
            <span
                role="img"
                aria-label={hint}
                tabIndex={0}
                style={{
                    display: 'inline-block',
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: descriptor.value === 0 ? 'transparent' : (descriptor.color || '#8c8c8c'),
                    border: `1px solid ${descriptor.color || '#8c8c8c'}`,
                }}
            />
        </Tooltip>
    );
};

export default TaskPriority;
